import styles from './index.scss';
import { generatePrefixedTagName } from '../generate-prefixed-tag-name';
import { safelyDefineCustomElement } from '../safely-define-custom-element';

export class BannerContent extends HTMLElement {
    static get tagName() {
        return  generatePrefixedTagName`banner-content`;
    }

    constructor() {
        super();

        this.attachShadow({ mode: 'open' });
    }

    async connectedCallback() {
        this.shadowRoot.innerHTML = `<style>${styles}</style>
        <div class="message-container">
            <slot></slot>
        </div>`;
    }
}

safelyDefineCustomElement(BannerContent);